import { render, staticRenderFns } from "./rightsidebarImg.vue?vue&type=template&id=350edcf6&scoped=true"
import script from "./rightsidebarImg.vue?vue&type=script&lang=js"
export * from "./rightsidebarImg.vue?vue&type=script&lang=js"
import style0 from "./rightsidebarImg.vue?vue&type=style&index=0&id=350edcf6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "350edcf6",
  null
  
)

export default component.exports